import React, { Fragment } from 'react'

import { useUnit } from 'effector-react'

import { useMediaQueries, useSelector } from 'hooks'

import Button from 'components/_old/Button/Button.jsx'
import Input from 'components/_old/Input/Input.jsx'
import Label from 'components/_old/Label/Label.jsx'
import { Typo } from 'components/_old/Typo/Typo'
import Validate from 'components/_old/Validate/Validate.jsx'
import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { TwoFactorSetupLayout } from '../TwoFactorSetupLayout'

import { $isLoading, $phoneNumber, setPhoneNumber, initPhoneConfirmation, $validation, $isValid } from './model'
import { SmsFormModal } from './SmsFormModal'

const PhoneNumberStep = (): React.ReactElement => {
  const { desktop } = useMediaQueries()

  const client = useSelector((state) => state.client)

  const [isLoading, phoneNumber, handleSetPhoneNumber, handleInitPhoneConfirmation, validation, isValid] = useUnit([
    $isLoading,
    $phoneNumber,
    setPhoneNumber,
    initPhoneConfirmation,
    $validation,
    $isValid,
  ])

  const button = (
    <Button mods={{ size: 'big block' }} onClick={handleInitPhoneConfirmation} disabled={!isValid}>
      Send confirmation code
    </Button>
  )

  const content = (
    <Fragment>
      <Typography size={desktop ? 32 : 24} weight="semibold" lineHeight="small" align="center">
        <Typo>Confirm your phone number</Typo>
      </Typography>
      <Paper top={8}>
        <Typography size={14} align="center">
          <Typo>If app notifications don’t work, we’ll send you a text message to help you access your account.</Typo>
        </Typography>
      </Paper>
      <Paper top={40}>
        <Width size={23.5} center>
          <Validate rules={validation.phone.rules}>
            <Label errorMessages={validation.phone.errors} mods={{ color: 'darkgray' }}>
              Phone
              <Input
                name="phone"
                type="tel"
                mods={{ size: 'bigger' }}
                country={client.country_code_by_ip}
                onChange={(_event, value) => {
                  handleSetPhoneNumber(value)
                }}
              >
                {phoneNumber}
              </Input>
            </Label>
          </Validate>
        </Width>
      </Paper>
    </Fragment>
  )

  return (
    <TwoFactorSetupLayout isLoading={isLoading} button={button}>
      <Paper top={40}>
        <Width size={45} center>
          {content}
        </Width>
      </Paper>
      {desktop && (
        <Paper top={56}>
          <Width size={23.5} center>
            {button}
          </Width>
        </Paper>
      )}

      <SmsFormModal />
    </TwoFactorSetupLayout>
  )
}

export { PhoneNumberStep }
